module.exports = __webpack_public_path__ + "img/landing_page.07d06da8.png";